import {Outlet, useParams} from 'react-router-dom'

import {isChatUpdates} from 'modules/chat'
import {useGetNotifications} from 'common/api'
import {Paper, Back, Loader, TabsPanel} from 'common/components'
import {Tab} from 'common/types'
import {
  useGetProject,
  useGetProjectConditions,
  useGetDrawdowns,
  isProjectRequest,
  hasOverdueConditions,
} from '..'

export default function BorrowerProject() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)
  const {data: conditions} = useGetProjectConditions(params.uuid)
  const {data: drawdowns} = useGetDrawdowns(params.uuid)
  const {data: notifications} = useGetNotifications()

  const backTo = project?.archived ? `/projects/archived` : '/projects'

  const tabs: Tab[] =
    !project || isProjectRequest(project)
      ? []
      : [
          {
            key: '',
            label: 'About',
          },
          {
            key: 'drawdowns',
            label: 'Drawdowns',
            badge: drawdowns?.some((drawdown) => drawdown.status === 'approved')
              ? 'red'
              : undefined,
          },
          {
            key: 'schedule',
            label: 'Schedule',
          },
          {
            key: 'conditions',
            label: 'Conditions',
            badge: hasOverdueConditions(conditions) ? 'red' : undefined,
          },
          {
            key: 'documents',
            label: 'Documents',
          },
        ]

  return (
    <Paper relative>
      <Back to={backTo} />
      {project ? (
        <>
          <TabsPanel
            isChatUpdates={isChatUpdates(notifications, project.uuid)}
            title={project.title}
            img={project.image}
            path={`projects/${project.uuid}`}
            tabs={tabs}
          />
          <Outlet />
        </>
      ) : (
        <Loader />
      )}
    </Paper>
  )
}
